<script lang="ts" module>
  import { AuthUnauthenticatedError } from '@/teoCore/errors/AuthError';
  import { useAuthState } from '@/ui/components/auth/use-auth.svelte';
  import { ConfigPanel } from '@/ui/components/config/';
  import { useActiveText, useTeoCore } from '@/utils/teo-context';

  import { useConfig } from './use-config.svelte';
</script>

<script lang="ts">
  let core = useTeoCore();
  let activeText = useActiveText();

  let authState = useAuthState();

  async function fetchConfigOptions() {
    if (!authState.current.loggedIn) {
      return new AuthUnauthenticatedError();
    }
    return core.getConfigOptions();
  }

  let [config, { setConfig }] = useConfig();
</script>

{#if activeText.current}
  {#key activeText.current}
    {#await fetchConfigOptions()}
      <ConfigPanel setup={null} values={config.current ?? {}} onChange={setConfig} />
    {:then options}
      <ConfigPanel setup={options} values={config.current ?? {}} onChange={setConfig} />
    {/await}
  {/key}
{/if}
